export default __webpack_public_path__ + "static/lxl-marzo-7c30f77ace167fe0e0061ae9607e412e.webp";